import { withBreakpointObserver } from '@studiometa/js-toolkit';
import { Slider as SliderCore, SliderItem, SliderBtn } from '@studiometa/ui';
import GalleryDots from './GalleryDots.js';
import SliderDrag from './SliderDrag.js';

/**
 * Slider component
 */
export default class Gallery extends withBreakpointObserver(SliderCore) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Gallery',
    components: {
      SliderItem,
      SliderDrag,
      GalleryDots,
      SliderBtn,
    },
  };
}
